<template>
    <div>
        <div>
            <sidebar-menu
                :menu="menu"
                width="100%"
                widthCollapsed="0"
                :class="menuClass"
                :collapsed="isSidebarCollapsed"
                @toggle-collapse="toggleSidebar"
                @item-click="onItemClick"
                :disableHover="true"
                :style="`--home-new-text:'${newRibbonLabel}'`"
            >
            </sidebar-menu>
        </div>
    </div>
</template>

<script>
    import { SidebarMenu } from 'vue-sidebar-menu'
    import loadingOverlay from 'components/shared/mixins/loadingOverlay'
    import { mapGetters } from 'vuex'
    import { viewTypes } from 'store/modules/search'

    export default {
        components: {
            SidebarMenu
        },
        mixins: [ loadingOverlay ],
        computed: {
            ...mapGetters({
                menuLogged: 'Menu/getMenuLogged',
                menuNonLogged: 'Menu/getMenuNonLogged',
                isLoggedIn: 'isLoggedIn',
                isSidebarCollapsed: 'getIsSidebarCollapsed',
                isSearchMobileCollapsed: 'getIsSearchMobileCollapsed'
            }),
            menu () {
                return this.isLoggedIn ? this.menuLogged : this.menuNonLogged
            },
            newRibbonLabel () {
                return `${this.$t('Ribbon.new')}!`
            },
            menuClass () {
                const menuClass = ['totem-sidebar']
                if (
                    !process.env.VUE_APP_SIDEMENU_NEW_RIBBON_EXPIRATION_DATE ||
                    +(new Date()) < +(new Date(process.env.VUE_APP_SIDEMENU_NEW_RIBBON_EXPIRATION_DATE))
                ) {
                    menuClass.push('with-new-ribbon')
                }
                return menuClass
            }
        },
        methods: {
            onItemClick (event, item) {
                if (item.attributes === undefined) {
                    return
                }

                if (item.attributes.id !== undefined) {
                    switch (item.attributes.id) {
                    case 'helpCenter':
                        this.goToHelpCenter()
                        this.toggleSidebar()
                        break
                    case 'logout':
                        this.logout()
                        this.toggleSidebar()
                        break
                    case 'category':
                        this.selectCategory(item)
                        this.toggleSidebar()
                        break
                    case 'knowledge-center':
                        this.goToKnowledgeCenter()
                        this.toggleSidebar()
                        break
                    case 'user-management':
                        this.goToUserManagement()
                        this.toggleSidebar()
                        break
                    case 'languages':
                        this.setSelectedLanguage(item.attributes.countryCode)
                        break
                    case 'login':
                    case 'userHub':
                    case 'organization-report':
                    case 'apphome':
                        this.toggleSidebar()
                        break
                    }
                }
            },
            goToLogin () {
                this.$router.push({ name: 'login' }).catch(err => {})
            },
            goToHelpCenter () {
                window.open(this.$t('Button.help_center_url'), '_blank')
            },
            goToKnowledgeCenter () {
                window.open(this.$t('StoreMenu.knowledge_center_url'), '_blank')
            },
            goToUserManagement () {
                window.open('https://app.eduhouse.'+ this.$totemLang  + '/admin', '_blank')
            },
            logout () {
                this.$store.dispatch('logout')
                this.$router.push({ name: 'home' }).catch(err => {})
            },
            selectCategory (option) {
                if (option.customerSpecific) {
                    this.$store.dispatch('Search/setViewType', viewTypes.learningPaths)
                } else {
                    this.$store.dispatch('Search/setViewType', viewTypes.all)
                }
                this.$store.dispatch('Search/setQuery', null)
                this.$store.dispatch('Search/clearAllFilters')

                if (option.href.params) {
                    this.$store.dispatch('Search/setMainPackage', option.href.params.packageSlug)
                }
            },
            toggleSidebar () {
                this.$store.dispatch('toggleSidebar')
                if (!this.isSearchMobileCollapsed) {
                    this.$store.dispatch('toggleSearchMobile')
                }
            },
            async setSelectedLanguage (countryCode) {
                await this.$store.dispatch('Languages/setSelectedLanguage', countryCode)
            }
        }
    }
</script>

<style lang="scss">
    .totem-sidebar {
        &.v-sidebar-menu {
            z-index: 1000;
            background-color: $white;
            top: 64px;

            &.with-new-ribbon {
                .vsm--icon.icon-home {
                    position: relative;
                }
                .vsm--icon.icon-home::after {
                    position: absolute;
                    left: 50%;
                    color: $carbon;
                    padding: 10px;
                    border-radius: 10px;
                    background: #f00;
                    line-height: 0;
                    transform: translateX(-50%);
                    font-family: Nunito-Bold, sans-serif;
                    font-size: 1rem;
                    content: var(--home-new-text);
                    text-transform: uppercase;
                }
            }

            .vsm--arrow_open {
                transform: rotate(270deg) !important;
                display: flex;
                align-items: center;
                justify-content: center;

            }

            .vsm--arrow {
                transform: rotate(90deg);
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .vsm--link_level-1 {
                .vsm--icon {
                    background-color: transparent;
                    color: $lavender;
                }
            }

            .vsm--badge-admin-tools {
                position: absolute;
                top: 25px;
                line-height: 0;
                font-size: 1.1rem;
                font-family: Quicksand-ExtraBold, sans-serif;
                color: $dove_gray;
                text-transform: uppercase;
            }

            .vsm--badge-help-center {
                position: absolute;
                right: 27px;
                top: 5px;
            }

            .vsm--badge-help-center::after {
                content: "\e948";
                font-family: 'icomoon';
                font-size: 2rem;
            }

            .vsm--blank-page:after {
                content: "\e948";
                font-family: 'icomoon';
                font-size: 2rem;
            }

            .vsm--icon {
                font-size: 2rem;
                height: 30px;
                line-height: 30px;
                width: 30px;
                flex-shrink: 0;
                text-align: center;
                border-radius: 3px;
            }

            .vsm--icon-language {
                height: 20px !important;
                width: 25px !important;
                margin-right: 15px;
            }

            .vsm--toggle-btn {
                position: absolute;
                top: -52px;
                left: 10px;
                width: 42px;
                height: 41px;
                background-color: $light_blue;
                border-radius: 100%;
                line-height: normal !important;

                &:after {
                    font-family: 'icomoon';
                    content: "\e95f";
                    font-size: 2.3rem;
                    color: $black;
                    position: absolute;
                    top: 10px;
                    left: 10px;
                }
            }

            &.vsm_collapsed {
                margin: 0;
                .vsm--toggle-btn {
                    background-color: transparent;

                    &:after {
                        content: "\e962";
                        font-size: 2.6rem;
                        color: $tuatara;
                    }
                }
            }
        
            &.vsm_expanded .vsm--item_open .vsm--link_level-1 {
                background-color: $white;
                color: $carbon;

                .vsm--title {
                    color: $carbon;
                }

                .vsm--icon {
                    background: $white;
                }

                &:hover:not(.vsm--link_active) {
                    color: $carbon;
                }

                &.vsm--link_active {
                    background-color: $white;
                    color: $carbon;
                    .vsm--icon {
                        background-color: $white;
                    }
                }
            }

            .vsm--dropdown {
                border-top: 1px solid $silver_chalice;
                border-bottom: 1px solid $silver_chalice;

                & > .vsm--list {
                    padding: 0;
                    background-color: $bright_gray;

                    .vsm--link {
                        color: $carbon;
                        background: $bright_gray;
                        padding: 5px 20px;
                        word-break: break-word;
                        word-wrap: break-word;
                        white-space: pre-wrap;

                        &:hover {
                            color: $lavender;
                            font-family: PlusJakartaSans-Bold, sans-serif;
                        }

                        &.vsm--link_active:not(.vsm--link_exact-active) {
                            color: $carbon;

                            &:hover {
                                background-color: $black;
                                @include white(background, 0.5);
                            }
                        }

                        &.vsm--link_exact-active {
                            color: $lavender;
                            font-family: PlusJakartaSans-Bold, sans-serif;
                        }
                    }

                }
            }

            .vsm--link {
                padding: 8px 12px 8px 18px;
                height: 46px;
                color: $white;

                &._hover,
                &:hover {
                    @include white(background, 0.1);
                    color: $black;
                }

                &.bold {
                    font-family: Nunito-Bold, sans-serif;
                }
            }

            &.vsm_expanded .vsm--link {
                padding: 8px 18px;
            }

            .vsm--link_hover {
                @include white(background, 0.1);
            }

            .vsm--list {
                padding-left: 0;
                transition: 0.15s padding ease-out;
                margin-left: -1px;
            }

            .vsm--title {
                font-size: 1.5rem;
            }

            .vsm--arrow {
                &:after {
                    content: '\e930';
                    font-family: 'icomoon';
                    font-size: 2.6rem;
                }
            }

            .vsm--mobile-item {
                >.vsm--item >.vsm--link {
                    padding: 20px 20px 20px 0;
                    color: $carbon;
                }
                .vsm--title {
                    padding: 0;
                }
            }

            .vsm--mobile-bg {
                background-color: $heavy_metal;
            }

            .vsm--link_mobile-item,
            .vsm--link_mobile-item:hover {
                color: $white;
            }

            .vsm--link_exact-active,
            .vsm--link_active {
                font-weight: 400;
            }

            .vsm--link_level-1.vsm--link {
                color: $carbon;

                &:hover {
                    color: $black;
                }

                .vsm--title,
                .vsm--arrow {
                    color: $carbon;
                    font-weight: 300;

                    &:hover {
                        color: $black;
                        font-weight: 600;
                    }
                }
            }

            .vsm--link_level-1.vsm--link_exact-active,
            .vsm--link_level-1.vsm--link_active {
                box-shadow: none;
            }

            &.vsm_collapsed {
                .vsm--link_level-1.vsm--link_hover {
                    color: $white;
                    .vsm--icon {
                        background-color: transparent;
                        color: $white;
                    }
                }

                .vsm--link_level-1:hover .vsm--icon {
                    background-color: transparent;
                }

                .vsm--link_level-1.vsm--link_exact-active,
                .vsm--link_level-1.vsm--link_active {
                    background-color: transparent;
                }
            }
        }
    }
</style>
